import styles from "../styles.module.css";

type Props = {
  title: string;
  placeholder?: string;
  required?: boolean;
  value?: any;
  customValidity?: string;
  setter?: Function;
  hideAsterisk?: boolean;
};

const CampoTextoLongo = ({
  title,
  placeholder,
  required,
  value,
  customValidity,
  setter,
  hideAsterisk,
}: Props) => {
  return (
    <div className={styles.campo}>
      <label className={styles.title}>
        {title}
        <span className={styles.required}>{!hideAsterisk && "*"}</span>:
      </label>
      <div className={styles.icon}>
        <textarea
          value={value}
          placeholder={placeholder}
          maxLength={255}
          rows={4}
          className={setter ? "" : styles.borderNone}
          disabled={setter ? false : true}
          required={required}
          onInvalid={(e) => {
            if (customValidity) {
              e.currentTarget.setCustomValidity(customValidity);
            }
          }}
          onChange={(e) => {
            if (setter) {
              const v = e.target.value;
              setter(v);
              e.currentTarget.setCustomValidity("");
            }
          }}
        />
      </div>
    </div>
  );
};

export default CampoTextoLongo;
